import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, of, tap } from 'rxjs';
import { Dao } from '../dao';
import { DataLoader } from '../data-loader';
import { DataLoaderAuthentified } from '../data-loader-authentified';

@Injectable({
  providedIn: 'root',
})
export class ObjectiveDao extends Dao {
  private objective: DataLoaderAuthentified<any[]> = new DataLoaderAuthentified<
    any[]
  >(this.getAuthentified(), user => {
    return this.httpApi.get(`/accounts/${user.accountId}/objective`);
  });

  private reference: DataLoader<any[]> = new DataLoader<any[]>(() =>
    this.httpApi.get(`/ref/objective-types`),
  );

  private recommendation: DataLoader<any[]> = new DataLoader<any[]>(() =>
    this.httpApi.get(`/ref/recommendations/products`),
  );

  private recommendationWhen: DataLoader<any[]> = new DataLoader<any[]>(() =>
    this.httpApi.get(`/ref/recommendations/when`),
  );

  private recommendationHow: DataLoader<any[]> = new DataLoader<any[]>(() =>
    this.httpApi.get(`/ref/recommendations/how`),
  );

  private recommendationDetails: DataLoader<any[]> = new DataLoader<any[]>(() =>
    this.httpApi.get(`/ref/recommendations/detail`),
  );

  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  /* Objective */
  getObjective(): Observable<any> {
    return this.objective.get();
  }

  getObjectivesByMember(): Observable<any> {
    return this.command(user =>
      this.httpApi.get(`/accounts/${user.accountId}/objective`),
    );
  }

  saveObjectivesByMember(objectivesData: any): Observable<any> {
    return this.command(user => {
      const cleanedData = Object.entries(objectivesData).reduce(
        (acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        },
        {} as any,
      );

      // Si l'objet est vide, ne pas faire de requête
      if (Object.keys(cleanedData).length === 0) {
        return of(null);
      }

      return this.httpApi.patch(
        `/accounts/${user.accountId}/objective`,
        cleanedData,
      );
    }).pipe(tap(() => this.objective?.reset()));
  }

  saveObjective(entity: any): Observable<any> {
    let dto = { ...entity };
    return this.httpApi
      .patch(`/accounts/${entity.accountId}/objective`, dto)
      .pipe(tap(() => this.objective?.reset()));
  }

  getReference(): Observable<any[]> {
    return this.reference.get();
  }

  getRecommendation(): Observable<any[]> {
    return this.recommendation.get();
  }

  getRecommendationWhen(): Observable<any[]> {
    return this.recommendationWhen.get();
  }

  getRecommendationHow(): Observable<any[]> {
    return this.recommendationHow.get();
  }

  getRecommendationDetails(): Observable<any[]> {
    return this.recommendationDetails.get();
  }

  /* state */
  reset() {
    this.objective?.reset();
  }

  onUserChange(event: any) {
    this?.reset();
  }
}
